import { ToastMessageType } from "../components/toast/ToastContext";

export const ContactGroupToasts: { [key: string]: ToastMessageType } = {
  contactGroupCreated: {
    severity: "success",
    summary: "Kontaktgruppen-Erstellung erfolgreich",
    detail: "Die Kontaktgruppe wurde erfolgreich erstellt",
  },
  contactGroupCreationError: {
    severity: "error",
    summary: "Kontaktgruppen-Erstellung fehlgeschlagen",
    detail: "Die Kontaktgruppe konnte nicht erstellt werden",
  },
  contactGroupDeleted: {
    severity: "success",
    summary: "Kontaktgruppe entfernt",
    detail: "Das Kontaktgruppe wurde erfolgreich entfernt",
  },
  contactGroupeDeletionError: {
    severity: "error",
    summary: "Kontaktgruppen-Entfernung fehlgeschlagen",
    detail: "Die Kontaktgruppe konnte nicht entfernt werden",
  },
  contactGroupContactsSaved: {
    severity: "success",
    summary: "Kontaktgruppe aktualisiert",
    detail: "Die Kontaktgruppe wurde erfolgreich bearbeitet",
  },
  contactGroupContactsSaveError: {
    severity: "error",
    summary: "Speichern fehlgeschlagen",
    detail: "Die Kontaktgruppe konnte nicht bearbeitet werden",
  },
};
